"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appendGiphySDKRequestParam = exports.appendGiphySDKRequestHeader = exports.getGiphySDKRequestHeaders = void 0;
var gl = (typeof window !== 'undefined' ? window : global) || {};
// define _GIPHY_SDK_HEADERS_ if they don't exist
gl._GIPHY_SDK_HEADERS_ = gl._GIPHY_SDK_HEADERS_ || (gl.Headers ? new gl.Headers({
  'X-GIPHY-SDK-PLATFORM': 'web'
}) : undefined);
var getGiphySDKRequestHeaders = function getGiphySDKRequestHeaders() {
  return gl._GIPHY_SDK_HEADERS_;
};
exports.getGiphySDKRequestHeaders = getGiphySDKRequestHeaders;
var appendGiphySDKRequestHeader = function appendGiphySDKRequestHeader(key, value) {
  var _a;
  return (_a = (0, exports.getGiphySDKRequestHeaders)()) === null || _a === void 0 ? void 0 : _a.set(key, value);
};
exports.appendGiphySDKRequestHeader = appendGiphySDKRequestHeader;
var appendGiphySDKRequestParam = function appendGiphySDKRequestParam(key, value) {
  var _a;
  return (_a = (0, exports.getGiphySDKRequestHeaders)()) === null || _a === void 0 ? void 0 : _a.set(key, value);
};
exports.appendGiphySDKRequestParam = appendGiphySDKRequestParam;